//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"MaterialName",1,1],[0,"ShadowCastingDisabled",1,1],[0,"TechniqueType",1,1],[0,"TextureSpaceShaderType",1,1],[0,"UseCameraDirectionPlaneOption",1,1]],[[["nAttributeValues"],"GetAttributeValues",{R_:{attributeValues:"NXObject[]"}},0,1],[["attributeValues"],"SetAttributeValues",{},1,1],[[],"UpdateMaterialsInPartPaletteEntry",{},0,1]],[]];
SPLM.Display.CgfxMattexBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.CgfxMattexBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.CgfxMattexBuilder.Technique = Object.freeze({
    "Base" : "Base"});

SPLM.Display.CgfxMattexBuilder.TextureSpace = Object.freeze({
    "DefaultUv" : "DefaultUv", "Edited" : "Edited"});

SPLM.Display.CgfxMattexBuilder.TextureSpaceShader = Object.freeze({
    "ArbitraryPlane" : "ArbitraryPlane", "Cylindrical" : "Cylindrical", "Spherical" : "Spherical", "WcsAutoAxis" : "WcsAutoAxis", "Uv" : "Uv", "CameraDirectionPlane" : "CameraDirectionPlane"});

SPLM.Display.CgfxMattexBuilder.UseCameraDirectionPlane = Object.freeze({
    "NormalVector" : "NormalVector", "NormalAndUpVector" : "NormalAndUpVector"});

export default SPLM;